/* eslint class-methods-use-this: 0 */
import { IGridHelper } from '@components-clean/core/api-grid/helpers/interfaces';
import { ColumnDefinition } from '@interfaces/central-monitoring';

enum ActionsGridColumns {
    Association = 'association',
    AssociationActive = 'association_active',
    Panel = 'panel',
    PanelActive = 'panel_active',
    OwnerActive = 'owner_active',
    CreatedBy = 'created_by',
    CreatedDate = 'created_date',
    UpdatedBy = 'updated_by',
    UpdatedDate = 'updated_date',
    ResponsibleFunction = 'responsible_function',
    ResponsibleFunctionActive = 'responsible_function_active',
    Id = 'id',
    RecordId = 'record_id',
    ObservationId = 'observation_record_id',
    Owner = 'owner',
    Resolution = 'resolution',
    Description = 'description',
    Comments = 'comments',
    Status = 'status',
    RequestedDate = 'requested_date',
    DueDate = 'due_date',
    CompletedDate = 'completed_date',
    CompletedDatePopulatedOn = 'completed_date_populated_on',
    Site = 'site',
    IntegrationEnabled = 'integration_enabled',
    IntegrationStatue = 'integration_state',
    IntegrationUpdated = 'integration_updated',
    IntegrationNotes = 'integration_notes',
}

export class ActionsGridHelper implements IGridHelper {
    getDisplayFields(columnType: ColumnDefinition) {
        switch (columnType.dataField) {
            case ActionsGridColumns.AssociationActive:
            case ActionsGridColumns.PanelActive:
            case ActionsGridColumns.OwnerActive:
            case ActionsGridColumns.CreatedBy:
            case ActionsGridColumns.CreatedDate:
            case ActionsGridColumns.UpdatedBy:
            case ActionsGridColumns.UpdatedDate:
            case ActionsGridColumns.ResponsibleFunctionActive:
            case ActionsGridColumns.Id:
            case ActionsGridColumns.ObservationId:
            case ActionsGridColumns.RecordId:
                return false;
            default:
                return true;
        }
    }

    getActiveField(columnType: ColumnDefinition) {
        switch (columnType.dataField) {
            case ActionsGridColumns.Association:
            case ActionsGridColumns.Panel:
            case ActionsGridColumns.ResponsibleFunction:
            case ActionsGridColumns.Owner: {
                return `${columnType.dataField}_active`;
            }
            default:
                return undefined;
        }
    }

    getDisplayTooltipFields(columnType: ColumnDefinition) {
        switch (columnType.dataField) {
            case ActionsGridColumns.Description:
            case ActionsGridColumns.Resolution:
            case ActionsGridColumns.Owner:
            case ActionsGridColumns.Comments:
            case ActionsGridColumns.Association:
            case ActionsGridColumns.Panel:
            case ActionsGridColumns.ResponsibleFunction:
            case ActionsGridColumns.IntegrationNotes:
                return true;
            default:
                return false;
        }
    }

    isRagColumn() {
        return false;
    }

    disableLock() {
        return false;
    }

    multiValueFilter() {
        return false;
    }

    actionsColumnsWidth: Map<string | null | undefined, number> = new Map([
        [ActionsGridColumns.Status, 110],
        [ActionsGridColumns.Site, 115],
        [ActionsGridColumns.Association, 180],
        [ActionsGridColumns.Panel, 180],
        [ActionsGridColumns.Description, 400],
        [ActionsGridColumns.Comments, 200],
        [ActionsGridColumns.Owner, 200],
        [ActionsGridColumns.Resolution, 200],
        [ActionsGridColumns.ResponsibleFunction, 190],
        [ActionsGridColumns.RequestedDate, 145],
        [ActionsGridColumns.DueDate, 145],
        [ActionsGridColumns.CompletedDate, 145],
        [ActionsGridColumns.CompletedDatePopulatedOn, 185],
        [ActionsGridColumns.CreatedDate, 145],
        [ActionsGridColumns.UpdatedDate, 145],
        [ActionsGridColumns.CreatedBy, 145],
        [ActionsGridColumns.UpdatedBy, 145],
        [ActionsGridColumns.RecordId, 100],
        [ActionsGridColumns.ObservationId, 100],
    ]);

    getColumnWidth(columnType: ColumnDefinition): number | undefined {
        return this.actionsColumnsWidth.get(columnType.dataField);
    }

    getCustomCell() {
        return undefined;
    }

    disableAdvancedFilter() {
        return false;
    }
}
